import { Device } from "./Device";

export class DeviceSubordinate {
	public Device: Device;

	constructor(device: Device) {
		this.Device = device;
	}
}
